import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=66514750&"
import script from "./MonitorList.vue?vue&type=script&lang=js&"
export * from "./MonitorList.vue?vue&type=script&lang=js&"
import style0 from "./MonitorList.vue?vue&type=style&index=0&id=66514750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports